export let SwagBundleAddonTypeInEditApprovePopupEnum = /*#__PURE__*/function (SwagBundleAddonTypeInEditApprovePopupEnum) {
  SwagBundleAddonTypeInEditApprovePopupEnum["Notecard"] = "notecard";
  SwagBundleAddonTypeInEditApprovePopupEnum["Packaging"] = "packaging";
  SwagBundleAddonTypeInEditApprovePopupEnum["BothAddons"] = "both";
  return SwagBundleAddonTypeInEditApprovePopupEnum;
}({});